<template>
  <component
    :is="to ? 'router-link' : 'div'"
    class="text-decoration-none d-flex"
    :to="to ? to : null"
  >
    <v-progress-circular
      v-if="loading"
      color="grey-lighten-3"
      indeterminate
      width="2"
    />
    <img
      v-if="!loading"
      alt="logo"
      class="logo logo--fade_in"
      :height="dimensions.height"
      :src="logo.url"
      :width="dimensions.width"
    />
  </component>
</template>

<script>
export default {
  name: 'NavLogo',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    logo: {
      type: Object,
      default: () => ({
        height: 32,
        width: 32,
        url:
          '//res.cloudinary.com/bandwango/image/upload/v1643751153/noimg_ahhwzj.jpg'
      })
    },
    maxHeight: {
      type: Number,
      default: 32
    },
    maxWidth: {
      type: Number,
      default: 128
    },
    to: {
      type: Object,
      default: null
    }
  },
  computed: {
    intendedRatio() {
      return this.maxWidth / this.maxHeight;
    },
    dimensions() {
      const actualRatio = this.logo.width / this.logo.height;
      return {
        height:
          actualRatio > this.intendedRatio
            ? this.logo.height / (this.logo.width / this.maxWidth)
            : this.maxHeight,
        width:
          actualRatio > this.intendedRatio
            ? this.maxWidth
            : this.logo.width / (this.logo.height / this.maxHeight)
      };
    }
  }
};
</script>

<style lang="scss">
.logo {
  opacity: 0;
  transition: opacity 0.3s;

  &--fade_in {
    opacity: 1;
  }
}
</style>
